import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getAllCustomerRNPL, getCustomerVehiclesById, getFleetPoliciesByCustomer, getNonMotorPoliciesByCustomer, getPoliciesByCustomer, runPaymentAnalysisOnCustomer } from '../../../api/requests';
import { Customer } from '../../../models/customer/Customer';
import Loader from '../../../components/Loader';
import moment from 'moment';
import { capitalizeSentence, getFormattedPhoneNumber, getIdTypeFromValue, getNationalityName, getPhoneNumberFromShortCodeFormat, sentenceCase } from '../../../utils/miscFunctions';
import useUserAccount from '../../../hooks/userAccountHook';
import useRoute from '../../../hooks/routesHook';
import useModal from '../../../hooks/modalHook';
import { CUSTOMER_TYPE, ID_TYPES_DTO, REDACT_INFO_TYPES } from '../../../resources/enums';
import clsx from 'clsx';
import GTable from '../../../components/elements/GTable';
import { User, Phone, MapPin, CreditCard, Briefcase, Calendar, CheckCircle, CheckSquare, Mail, PencilIcon } from 'lucide-react';
import EditCustomer from './EditCustomer';
import TabContent from '../../../components/tabs/TabContent';
import TabNav, { ITab } from '../../../components/tabs/TabNav';
import { ITask } from '../../../resources/interfaces';
import CreateTask from '../../admin/leads/CreateTask';
import { TwoStateVerifiedCheck } from '../../../components/statuses';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import CustomerUpdates from './CustomerUpdates';
import PostsaleChecklist from '../../../components/customer/PostsaleChecklist';
import useCustomer from '../../../hooks/customerHook';
import { useSelector } from 'react-redux';
import { getSelectedCountry } from '../../../states/slices/resourceSlice';
import KycAnalysis from '../../../components/customer/KycAnalysis';
import ActionsPopOnMe from '../../../components/ActionsPopOnMe';
import Avatar from '../../../components/Avatar';
import DocumentDownloadCard from '../../../components/cards/DocumentDownloadCard';
import ToolTip from '../../../components/ToolTip';
import RedactInfo from '../../../components/elements/RedactInfo';
import BackButton from '../../../components/BackButton';
import PaymentAnalysis from '../../../components/PaymentAnalysis';
import PreviewImage from '../../../components/elements/PreviewImage';

export interface IVerifyCustomerDTO {
  accountProviders: string;
  customerId?: number | string;
  identifier: string;
  verificationCode: string;
}

interface ICustomerDetailsProps {
  previousPath: string;
}

const ViewCustomer = (props: ICustomerDetailsProps): JSX.Element => {
  const navigate = useNavigate();
  const [customerVehicles, setCustomerVehicles] = useState<any[]>([]);
  const [searchParams] = useSearchParams();
  const { fetchCustomerReferrals, CustomerModalComponent, showUpdateTaskModal, showEditCustomerModal, setSingleCustomer, fetchCustomer,
    singleCustomer, RNPLColumns, referralColumns, taskColumns, fleetColumns, nonMotorColumns, autoPoliciesColumns } = useCustomer();
  const { user } = useUserAccount();
  const { getDashboardBase } = useRoute();
  const { id } = useParams();
  const pageRef = useRef<HTMLDivElement>(null);
  const { ModalComponent, updateModalStates, closeModal } = useModal();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') ?? 'autoPolicies');
  const [completedChecklist, setCompletedChecklist] = useState<string[]>([]);
  const queryClient = useQueryClient();
  const [showUpdates, setShowUpdates] = useState<boolean>(false);
  const [RNPL, setRNPL] = useState<any>();
  const [paymentAnalysis, setPaymentAnalysis] = useState()
  const selectedCountry = useSelector(getSelectedCountry);
  const countryId = selectedCountry?.id ?? 1
  const page = 0;
  const hasPageHistory = window.history.length > 1
  const [fleetPolicies, setFleetPolicies] = useState<any[]>([]);
  const [nonMotorPolicies, setNonMotorPolicies] = useState<any[]>([]);
  const [individualPolicies, setIndividualPolicies] = useState<any[]>([]);
  const [customer, setCustomer] = useState<Customer>()

  useEffect(() => {
    singleCustomer && setCustomer(singleCustomer)
  }, [singleCustomer])


  const getTabs = () => {
    let tabs: ITab[] = [
      {
        id: 'autoPolicies',
        title: 'Motor',
        itemCount: individualPolicies?.length || 0,
        // icon: <CreditCard />
      },
      // {
      //   id: 'fleet',
      //   title: 'Motor (Fleet)',
      //   itemCount: fleetPolicies?.length || 0,
      //   // icon: <CreditCard />
      // },
      {
        id: 'non-motor',
        title: 'Non-motor',
        itemCount: nonMotorPolicies?.length || 0,
        // icon: <Calendar />
      },
      {
        id: 'tasks',
        title: 'Tasks',
        itemCount: otherTasks && otherTasks?.length,
        // icon: <Calendar />
      },
    ];

    if (user.isInternalAdmin()) {
      tabs.push(
        {
          id: 'referrals',
          title: 'Referrals',
          itemCount: referrals?.length,
          // icon: <User />
        },
        {
          id: 'rnpl',
          title: 'RNPL',
          itemCount: RNPL && RNPL?.length,
          // icon: <Car />
        },)
    }

    return tabs;
  };

  const displayRNPLCustomer = () => {
    getAllCustomerRNPL(Number(id))
      .then((response: any) => {
        setRNPL(response?.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {

      });
  };

  const getAllCustomerIndividualPolicies = () => {
    id && getPoliciesByCustomer(id)
      .then((response: any) => {
        setIndividualPolicies(response)
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {

      });
  };

  const getAllCustomerFleetPolicies = () => {
    id && getFleetPoliciesByCustomer(id)
      .then((response: any) => {
        setFleetPolicies(response)
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {

      });
  };

  const getAllCustomerNonMotorPolicies = () => {
    id && getNonMotorPoliciesByCustomer(Number(id))
      .then((response: any) => {
        setNonMotorPolicies(response)
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {

      });
  };


  useEffect(() => {
    if (customer) {
      const completedList = customer.tasks ? customer.tasks.filter((task: ITask) => task.completed && typeof task.name === 'string' && postSaleChecklistTasks.some(postSaleTask => postSaleTask.name === task.name)
      ).map((task: ITask) => task.name ?? '') : [];
      setCompletedChecklist(completedList);
    }
  }, [customer]);


  const fetchCustomerVehicles = async () => {
    try {
      if (id) {
        const response: any = await getCustomerVehiclesById(id);
        setCustomerVehicles(response);
      }
    } catch (error) {
    }
  };

  const invalidateQueries = () => {
    queryClient.invalidateQueries({ queryKey: ['fetchCustomer'] });
  };

  const runPaymentAnalysis = () => {
    runPaymentAnalysisOnCustomer(Number(id))
      .then((response) => {
        setPaymentAnalysis(response);
        invalidateQueries()
      })
  }

  useQuery({
    queryKey: ['fetchCustomer'],
    queryFn: () => fetchCustomer(String(id))
  });

  useQuery({
    queryKey: ['fetchCustomerVehicles'],
    queryFn: fetchCustomerVehicles
  });

  useQuery({
    queryKey: ['getAllCustomerIndividualPolicies'],
    queryFn: getAllCustomerIndividualPolicies
  });

  useQuery({
    queryKey: ['getAllCustomerFleetPolicies'],
    queryFn: getAllCustomerFleetPolicies
  });

  const { isLoading: nonMotorPoliciesLoading } = useQuery({
    queryKey: ['getAllCustomerNonMotorPolicies'],
    queryFn: getAllCustomerNonMotorPolicies
  });

  const { data: referrals, isLoading: isReferralsLoading } = useQuery({
    queryKey: ['fetchCustomerReferrals', id],
    queryFn: () => fetchCustomerReferrals(id ?? ''),
  });

  useQuery({
    queryKey: ['displayRNPLCustomer', countryId],
    queryFn: () => displayRNPLCustomer(),
    enabled: activeTab === 'rnpl'
  });

  const showCreateTaskModal = (task?: ITask, selectedoption?: string | ITask) => {
    id &&
      updateModalStates({
        show: true,
        size: 'lg',
        children: (
          <CreateTask
            onProceed={() => {
              queryClient.invalidateQueries({ queryKey: ['fetchCustomer'] });
              closeModal();
            }}
            onClose={closeModal}
            id={id}
            isEdit={false}
            task={task}
            type={'CUSTOMER'}
            selectedOption={selectedoption}
          />
        ),
        title: 'Create New Task',
        classes: '!p-0 r-[5px]'
      });
  };


  const getActions = () => {
    let actions = [
      {
        label: 'Edit',
        callback: () => customer && showEditCustomerModal(customer),
        icon: <PencilIcon className='h-4 w-4' />
      },
      {
        label: 'Create task',
        callback: () => showCreateTaskModal(),
        icon: <Calendar className='h-4 w-4' />
      }
    ];

    actions.push({
      label: `View / add ${customer?.customerUpdates?.length === 1 ? ' update' : ' updates'}`,
      callback: () => setShowUpdates(true),
      icon: <CheckCircle className='h-4 w-4' />
    });

    return actions;
  };

  const openPictureModal = (imgURL: string) => {

    imgURL && updateModalStates({
      children: (
        <PreviewImage onClose={closeModal} imgURL={imgURL} />
      ),
      show: true,
      size: '3xl',
      hidePanelStyles: true,
      showTitleSection: false,
    });
  };

  const handleTabClicked = (id: string) => {
    navigate(`${getDashboardBase()}/customers/${customer?.id}?tab=${id}`);
  };

  const postSaleChecklistTasks = customer?.tasks && Array.isArray(customer?.tasks) ? customer?.tasks?.filter((task) => task.type === "Post-sale checklist").map((task) => task) : [];
  const otherTasks = customer?.tasks && Array.isArray(customer?.tasks) ? customer?.tasks?.filter((task) => task.type !== "Post-sale checklist").map((task) => task) : [];


  const getPersonalProfile = () => {
    return (
      <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 dark:bg-transparent dark:border-darkBg-border">
          <h2 className="text-lg font-medium text-gray-900 flex items-center dark:text-darkBg-mainText">
            <User className="h-5 w-5 mr-2 text-gray-500 dark:text-darkBg-mainText" />
            Personal Profile
          </h2>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <CustomerDetailsItem name={'Date of Birth'} value={customer?.dateOfBirth ? moment(customer.dateOfBirth).format('Do MMM, YYYY') : '-'} append={customer?.dateOfBirth ? `${new Date().getFullYear() - new Date(customer.dateOfBirth).getFullYear()} years` : ''} />

            <CustomerDetailsItem name={'Gender'} value={customer?.gender ? capitalizeSentence(customer.gender) : '-'} />

            <CustomerDetailsItem name={'Marital Status'} value={'-'} />

            <CustomerDetailsItem name={'Nationality'} value={customer?.country ? getNationalityName(customer?.country) : '-'} />

            <CustomerDetailsItem name={'Tax ID'} value={'-'} />
          </div>
        </div>
      </div>
    )
  }

  const getIDInformation = () => {
    const formattedAddress = `${customer?.address}, ${customer?.city ? `${customer?.city}, ` : ''} ${customer?.country}`

    return (
      <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 dark:bg-transparent dark:border-darkBg-border">
          <h2 className="text-lg font-medium text-gray-900 flex items-center dark:text-darkBg-mainText">
            <CreditCard className="h-5 w-5 mr-2 text-gray-500 dark:text-darkBg-mainText" />
            ID Information
          </h2>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <CustomerDetailsItem name={'ID Type'} value={customer?.idType ? getIdTypeFromValue(customer?.idType) : '-'} />
            <CustomerDetailsItem name={`${customer?.idType === ID_TYPES_DTO.TIN ? 'TIN Number' : 'ID Number'}`} value={customer?.idNumber ?? '-'} append={<TwoStateVerifiedCheck verified={customer?.idVerified} />} />
            <CustomerDetailsItem name={'Expiry Date'} value={customer?.idExpiryDate ? moment(customer?.idExpiryDate).format('Do MMM, YYYY') : '-'} />
            {customer && customer?.customerType === CUSTOMER_TYPE.BUSINESS && <CustomerDetailsItem
              name={'Incorporation Date'}
              value={customer?.incorporationDate ? moment(customer?.incorporationDate).format('Do MMM, YYYY') : '-'}
            />}
            <CustomerDetailsItem name={'Issuing Country'} value={customer?.country ?? '-'} />
            <CustomerDetailsItem
              name="Home Address"
              prepend={<MapPin className="h-4 w-4 mr-1 mt-0.5 text-gray-500" />}
              append={
                <ToolTip
                  message={
                    <RedactInfo
                      info={formattedAddress ?? ''}
                      totalToRedact={formattedAddress?.length}
                      dataId={customer?.id ?? ''}
                      dataType="customer"
                      infoType={REDACT_INFO_TYPES.ADDRESS}
                    />
                  }>

                  <div className="text-sm text-gray-900 capitalize truncate w-full max-w-24">
                    {formattedAddress ? (
                      <RedactInfo
                        info={formattedAddress}
                        totalToRedact={formattedAddress?.length}
                        dataId={customer?.id ?? ''}
                        dataType="customer"
                        infoType={REDACT_INFO_TYPES.ADDRESS}
                      />
                    ) : '-'}
                  </div>

                </ToolTip>
              } />
          </div>
        </div>
      </div>
    )
  }

  const getEmploymentInformation = () => {
    return (
      <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 dark:bg-transparent dark:border-darkBg-border">
          <h2 className="text-lg font-medium text-gray-900 flex items-center dark:text-darkBg-mainText">
            <Briefcase className="h-5 w-5 mr-2 text-gray-500 dark:text-darkBg-mainText" />
            Employment Information
          </h2>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <CustomerDetailsItem name="Employment Status" value={customer?.employerName ? 'Employed' : 'Unemployed'} />
            <CustomerDetailsItem name="Occupation" value={customer?.occupation ? customer?.occupation : '-'} />
            <CustomerDetailsItem name="Employer" value={customer?.employerName ? customer?.employerName : '-'} />

            <CustomerDetailsItem name="Employer Address" append={
              <ToolTip
                message={
                  <RedactInfo
                    info={customer?.employerAddress ?? ''}
                    totalToRedact={customer?.employerAddress?.length}
                    dataId={customer?.id ?? ''}
                    dataType="customer"
                  />
                }>
                <div className="text-sm text-gray-900 capitalize truncate w-full max-w-24">
                  {customer?.employerAddress ? (
                    <RedactInfo
                      info={customer?.employerAddress}
                      totalToRedact={customer?.employerAddress?.length}
                      dataId={customer?.id ?? ''}
                      dataType="customer"
                    />
                  ) : '-'}
                </div>

              </ToolTip>
            } />

            <CustomerDetailsItem name="Employer Phone" value={customer?.employerPhone ? getPhoneNumberFromShortCodeFormat(customer?.employerPhone) : '-'} />
          </div>
        </div>
      </div>
    )
  }

  const getContactInformation = () => {
    const formattedAddress = `${customer?.address}, ${customer?.city ? `${customer?.city}, ` : ''} ${customer?.country}`
    return (
      <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 dark:bg-transparent dark:border-darkBg-border">
          <h2 className="text-lg font-medium text-gray-900 flex items-center dark:text-darkBg-mainText">
            <Phone className="h-5 w-5 mr-2 text-gray-500 dark:text-darkBg-mainText" />
            Contact Information
          </h2>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <CustomerDetailsItem name="Preferred Contact Method" value={'-'} />



            <CustomerDetailsItem
              name="Home Address"
              prepend={<MapPin className="h-4 w-4 mr-1 mt-0.5 text-gray-500" />}
              append={
                <ToolTip
                  message={
                    <RedactInfo
                      info={formattedAddress ?? ''}
                      totalToRedact={formattedAddress?.length}
                      dataId={customer?.id ?? ''}
                      dataType="customer"
                      infoType={REDACT_INFO_TYPES.ADDRESS}
                    />
                  }>

                  <div className="text-sm text-gray-900 capitalize truncate w-full max-w-24">
                    {formattedAddress ? (
                      <RedactInfo
                        info={formattedAddress}
                        totalToRedact={formattedAddress?.length}
                        dataId={customer?.id ?? ''}
                        dataType="customer"
                        infoType={REDACT_INFO_TYPES.ADDRESS}
                      />
                    ) : '-'}
                  </div>

                </ToolTip>
              } />
          </div>
        </div>
      </div>
    )
  }

  const getContactPersonInformation = () => {
    const formattedAddress = `${customer?.address}, ${customer?.city ? `${customer?.city}, ` : ''} ${customer?.country}`

    return (
      <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 dark:bg-transparent dark:border-darkBg-border">
          <h2 className="text-lg font-medium text-gray-900 flex items-center dark:text-darkBg-mainText">
            <Phone className="h-5 w-5 mr-2 text-gray-500 dark:text-darkBg-mainText" />
            Contact Person Information
          </h2>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            <CustomerDetailsItem name={'Name'} value={customer?.firstName ? `${customer?.firstName} ${customer?.lastName}` : '-'} />

            <CustomerDetailsItem name={'Phone No.'} value={customer?.phone ? getPhoneNumberFromShortCodeFormat(customer?.phone) : '-'} />
          </div>
        </div>
      </div>
    )
  }

  const scrollToPaymentHistory = () => {
    if (pageRef.current) {
      pageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div className="">
      {(!customer) && (
        <div className="min-h-screen flex items-center justify-center">
          <Loader message="Fetching customer. Please wait..." brollyLoaderFixed />
        </div>
      )}

      {customer && (
        <div className="p-6">
          {/* Page header with breadcrumb and actions */}
          <div className={`mb-6 flex w-full items-center ${hasPageHistory ? 'justify-between' : 'justify-end'}`}>
            {/* <BackButton onClick={() => navigate(`${props.previousPath}`)} /> */}
            {hasPageHistory && <BackButton onClick={() => navigate(-1)} />}

            <ActionsPopOnMe actions={getActions()} popOptionClasses="" />
          </div>

          {/* Main content */}
          <div className="space-y-6">

            {/* Customer Header with Profile Picture */}
            <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
              <div className="p-6">
                <div className="flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0 md:space-x-6">
                  <div className="flex-shrink-0">
                    <Avatar
                      nameInitials={`${customer?.firstName} ${customer?.lastName}`}
                      src={customer?.customerDocuments?.[0]?.docUrl}
                      size="lg"
                    />
                  </div>

                  <div className="flex-1 text-center md:text-left">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-darkBg-mainText">{customer?.customerType === CUSTOMER_TYPE.INDIVIDUAL ? `${customer?.firstName + ' ' + customer?.lastName}` : customer?.businessName || customer?.fullName}</h1>
                    <p className="text-sm text-gray-500 mt-1 dark:text-darkBg-mainText">
                      Customer ID: {customer?.id}
                    </p>

                    <div className={`flex items-center  w-fit mt-2 py-0.5 px-2 rounded-full text-[9px] bg-orange-100 text-orange-800`}>
                      <User className='h-5 w-5' />
                      <span className="ml-1 font-medium capitalize whitespace-nowrap text-sm">Type: {customer?.customerType ? sentenceCase(customer?.customerType) : '-'}</span>
                    </div>
                    <div className="mt-3 flex flex-wrap justify-center md:justify-start gap-2">
                      <span className={`px-2 py-1 text-xs font-medium rounded-full ${customer?.idVerified ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                        }`}>
                        {customer?.idVerified ? 'Verified' : 'Not Verified'}
                      </span>
                    </div>
                    <div className="mt-4 flex flex-wrap justify-center md:justify-start gap-4">
                      <div className="flex items-center">
                        <Mail className="h-4 w-4 mr-1 text-gray-500 dark:text-darkBg-mainText" />
                        {customer?.email ? <><span className="text-sm text-gray-600 dark:text-darkBg-mainText">{customer?.email}</span>
                          <TwoStateVerifiedCheck verified={customer?.emailVerified} /></> : '-'}
                      </div>
                      <div className="flex items-center">
                        <Phone className="h-4 w-4 mr-1 text-gray-500 dark:text-darkBg-mainText" />
                        {customer?.phone ? <><span className="text-sm text-gray-600 dark:text-darkBg-mainText">{customer?.phone ? getPhoneNumberFromShortCodeFormat(customer?.phone) : '-'}</span>
                          <TwoStateVerifiedCheck verified={customer?.phoneVerified} /></> : '-'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Two-column grid for sections */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              {/* Left Column */}
              <div className="space-y-6">
                {/* Personal Profile Section */}
                {customer?.customerType === CUSTOMER_TYPE.INDIVIDUAL && getPersonalProfile()}

                {/* ID Information Section */}
                {getIDInformation()}

                {/* Contact Information Section */}
                {/* {getContactInformation()} */}

                {/* Contact Person Information Section */}
                {customer?.customerType === CUSTOMER_TYPE.BUSINESS && getContactPersonInformation()}

                {/* Employment Information Section */}
                {customer?.customerType === CUSTOMER_TYPE.INDIVIDUAL && getEmploymentInformation()}

                {/* Documents Section */}
                {!(user.isRideSharing() && user.isInsurer()) && (
                  <DocumentDownloadCard title="Documents" documents={customer?.customerDocuments} openPictureModal={openPictureModal} isCustomer={true} />
                )}
              </div>

              {/* Right Column */}
              <div className="space-y-6">

                {/* KYC Analysis Section */}
                <KycAnalysis kycAnalysis={customer?.kycAnalysis} id={customer?.id}
                  onproceed={() => {
                    queryClient.invalidateQueries({ queryKey: ['fetchCustomer'] });
                  }} />


                {/* Payment Analysis Section */}
                {/* {customer?.paymentAnalysis && (
                  <PaymentAnalysis customer={customer} />
                )} */}
                {/* <div className='mt-5'>
                  <PaymentAnalysis
                    paymentAnalysis={customer?.paymentAnalysis}
                    handleRunPaymentAnalysis={runPaymentAnalysis}
                    handleViewFullPayment={scrollToPaymentHistory}
                    currency={'GHS'}
                  />
                </div> */}


              </div>
            </div>

            {/* Post-Sale Checklist Section */}
            {(user.isInternalAdmin()) && (
              <div className="bg-white rounded-2xl shadow dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border ">
                <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 dark:bg-transparent dark:border-darkBg-border">
                  <h2 className="text-lg font-medium text-gray-900 flex items-center dark:text-darkBg-mainText">
                    <CheckSquare className="h-5 w-5 mr-2 text-gray-500 dark:text-darkBg-mainText" />
                    Post-Sale Checklist
                  </h2>
                </div>

                <div className="p-6 max-h-[500px] overflow-y-scroll">
                  <PostsaleChecklist
                    options={postSaleChecklistTasks}
                    completedOptions={completedChecklist}
                    onOptionChange={(option: string, remove?: boolean) => {
                      if (remove) {
                        setCompletedChecklist(completedChecklist.filter((item) => item !== option));
                      } else {
                        setCompletedChecklist([...completedChecklist, option]);
                      }
                    }}
                    onClick={(option) => {
                      let task: any;
                      showUpdateTaskModal(task, option);
                    }}
                  />
                </div>
              </div>
            )}

            {/* Tabs */}
            {!user.isFinancier() && (
              <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border" ref={pageRef} >
                <div className="flex gap-5">
                  <TabNav
                    tabs={getTabs()}
                    activeTab={activeTab}
                    onTabClicked={handleTabClicked}
                    setActiveTab={(id: string) => {
                      setActiveTab(id);
                    }}
                  />
                </div>

                <div className="max-h-[500px] overflow-y-scroll">
                  {/* customer Tasks */}
                  <TabContent id={'tasks'} activeTab={activeTab}>
                    {customer && customer.tasks && customer.tasks.length > 0 && !(user.isInsurer() && user.isRideSharing()) ? (
                      <div className=" my-5 ">
                        <GTable
                          columns={taskColumns}
                          data={otherTasks || []}
                          classes="h-fit"
                          showSearch={false}
                          tableType={'task'}
                          stickyHeader
                        />
                      </div>
                    ) : (
                      <div className="h-20 flex items-center justify-center text-lg">No task found </div>
                    )}
                  </TabContent>

                  {user.isInternalAdmin() &&
                    <>
                      {/* customer referrals */}
                      <TabContent id={'referrals'} activeTab={activeTab}>

                        <div className=" my-5 ">
                          <GTable
                            columns={referralColumns}
                            data={referrals || []}
                            classes="h-fit"
                            showSearch={false}
                            tableType={'referral'}
                            stickyHeader
                          />
                        </div>

                      </TabContent>


                      {/* RNPL */}
                      <TabContent id={'rnpl'} activeTab={activeTab}>

                        <div className=" my-5 ">
                          <GTable
                            columns={RNPLColumns}
                            data={RNPL ?? []}
                            classes="h-fit"
                            showSearch={false}
                            tableType={'rnpl'}
                            stickyHeader
                          />
                        </div>

                      </TabContent>
                    </>
                  }

                  <TabContent id={'autoPolicies'} activeTab={activeTab}>
                    {!user.isRideSharing() && !user.isInsurer() && individualPolicies && (
                      <div className=" my-5 ">
                        <GTable
                          columns={autoPoliciesColumns}
                          data={individualPolicies ?? []}
                          showSearch={false}
                          tableType="auto policies"
                          columnClasses={clsx('w-fit')}
                          loading={false}
                          tableContainerId="tableId"
                          stickyHeader
                        />
                      </div>
                    )}
                  </TabContent>

                  {/* VEHICLES TABLE */}

                  {/* <TabContent id={'fleet'} activeTab={activeTab}>
                    {!user.isRideSharing() && !user.isInsurer() && fleetPolicies && (
                      <>
                        <div className=" my-5 ">
                          <GTable
                            columns={fleetColumns}
                            data={fleetPolicies ?? []}
                            showSearch={false}
                            tableType="fleet"
                            columnClasses={clsx('w-fit')}
                            loading={false}
                            tableContainerId="tableId"
                            stickyHeader
                          />
                        </div>

                        {!fleetPolicies && (
                          <div className="h-40 flex items-center justify-center text-lg">
                            No fleet found
                          </div>
                        )}
                      </>
                    )}
                  </TabContent> */}

                  {/* NON-MOTOR POLICIES TABLE */}
                  <TabContent id={'non-motor'} activeTab={activeTab}>
                    {!user.isRideSharing() && !user.isInsurer() && nonMotorPolicies && (
                      <>
                        <div className=" my-5 max-h-[200px] overflow-y-scroll">
                          <GTable
                            columns={nonMotorColumns}
                            data={nonMotorPolicies ?? []}
                            showSearch={false}
                            tableType="non-motor"
                            columnClasses={clsx('w-fit')}
                            loading={nonMotorPoliciesLoading}
                            tableContainerId="tableId"
                            stickyHeader
                          />
                        </div>

                        {!nonMotorPolicies && (
                          <div className="h-40 flex items-center justify-center text-lg">
                            No non-motor found
                          </div>
                        )}
                      </>
                    )}
                  </TabContent>

                </div>
              </div>
            )}


          </div>
        </div>
      )}

      {customer && showUpdates && (
        <CustomerUpdates
          show={showUpdates}
          onClose={() => {
            setShowUpdates(false);
          }}
          onProceed={() => { }}
          updates={customer?.customerUpdates ?? []}
          custumorId={customer.id}
          onCustomerUpdated={(customer: Customer) => setSingleCustomer(customer)}
        />
      )}

      <CustomerModalComponent />
      <ModalComponent />
    </div >
  );
};

type CustomerDetailsItemProps = {
  name: string;
  value?: string | JSX.Element;
  append?: React.ReactNode;
  prepend?: React.ReactNode;
};

const CustomerDetailsItem = ({ name, value, append, prepend }: CustomerDetailsItemProps) => {
  return (
    <div>
      <p className="text-sm font-medium text-gray-500">{name}</p>
      {prepend || append ? (
        <div className="flex items-center gap-1 mt-1">
          {prepend}
          <p className="text-sm text-gray-900 capitalize dark:text-darkBg-mainText">{value}</p>
          {append}
        </div>
      ) : (
        <p className="mt-1 text-sm text-gray-900 capitalize dark:text-darkBg-mainText">{value}</p>
      )}
    </div>
  );
};

export default ViewCustomer;
